import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getAllGroups,
  getFieldDetailsByDivisionID,
  getDivisionDetailsByEstateID,
  getEstateDetailsByGroupID,
  GetAllLeafType,
  GetExestingGreenLeafReceivingDeta,
  SaveGreenLeafReceivingData,
  getFactoryDetailsByGroupID,
  GetRouteByFactoryID,
  GetSuppliersByRouteID,
  getGreenLeafReceivingData,
  greenLeafReceivingDetailsBYID,
  UpdateGreenLeafReceivingData,
  getEstateByGroupID,
  DeleteGreenLeafReceivingDetails
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getEstateDetailsByGroupID(groupID,operationEntityTypeID) {
    let response = await CommonGet('/api/GreenLeafReceive/GetFactoryByGroupIDandOperationEntityTypeID', "groupID=" + parseInt(groupID) + '&operationEntityTypeID=' + parseInt(operationEntityTypeID));
    let estateArray = [];
    for (let item of Object.entries(response.data)) {
      estateArray[item[1]["factoryID"]] = item[1]["factoryName"];
    }
    return estateArray;
  };

  async function getFactoryDetailsByGroupID(groupID,operationEntityTypeID) {
    let response = await CommonGet('/api/GreenLeafReceive/GetFactoryByGroupIDandOperationEntityTypeID', "groupID=" + parseInt(groupID) + '&operationEntityTypeID=' + parseInt(operationEntityTypeID));
    let factoryArray = [];
    for (let item of Object.entries(response.data)) {
      factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
    }
    return factoryArray;
  };

  async function GetRouteByFactoryID(factoryID) {
    let response = await CommonGet('/api/Group/GetRouteByFactoryID', "factoryID=" + parseInt(factoryID));
    let RouteArray = [];
    for (let item of Object.entries(response.data)) {
      RouteArray[item[1]["routeID"]] = item[1]["routeName"];
    }
    return RouteArray;
  };

  async function GetSuppliersByRouteID(routeID) {
    let response = await CommonGet('/api/GreenLeafReceive/GetSuppliersByRouteID', "routeID=" + parseInt(routeID));
    let SuppliersArray = [];
    for (let item of Object.entries(response.data)) {
      SuppliersArray[item[1]["supplierID"]] = item[1]["supplierName"];
    }
    return SuppliersArray;
  };

async function getDivisionDetailsByEstateID(estateID) {
    let response = await CommonGet('/api/Division/getDivisionDetailsByEstateID', "estateID=" + parseInt(estateID));
    let divisionArray = [];
    for (let item of Object.entries(response.data)) {
      divisionArray[item[1]["divisionID"]] = item[1]["divisionName"];
    }
    return divisionArray;
  };

  async function getFieldDetailsByDivisionID(divisionID) {
    let response = await CommonGet('/api/Field/getFieldDetailsByDivisionID', "divisionID=" + parseInt(divisionID));
    let fieldArray = [];
    for (let item of Object.entries(response.data)) {
      fieldArray[item[1]["fieldID"]] = item[1]["fieldName"];
    }
    return fieldArray;
  };

async function GetAllLeafType() {
    let response = await CommonGet('/api/GreenLeafReceive/GetAllLeafType', null);
    let leafTypeArray = [];
    for (let item of Object.entries(response.data)) {
        leafTypeArray[item[1]["leafTypeID"]] = item[1]["leafTypeName"];
    }
    return leafTypeArray;
};

async function GetExestingGreenLeafReceivingDeta(model) {
    let response = await CommonPost('/api/GreenLeafReceive/GetExestingGreenLeafReceivingDeta', null, model);
    return response;
};

async function getGreenLeafReceivingData(model) {
  let response = await CommonPost('/api/GreenLeafReceive/GetGreenLeafReceivingData', null, model);
  return response;
};

async function SaveGreenLeafReceivingData(model) {
    try {
        return await CommonPost('/api/GreenLeafReceive/SaveGreenLeafReceivingData', null, model);
    } catch (error) {
        throw error;
    }
}

async function UpdateGreenLeafReceivingData(model) {
  try {
      return await CommonPost('/api/GreenLeafReceive/UpdateGreenLeafReceivingData', null, model);
  } catch (error) {
      throw error;
  }
}

async function greenLeafReceivingDetailsBYID(greenLeafReceivingDetailsID) {
   const response = await CommonGet('/api/GreenLeafReceive/GetGreenLeafReceivingDetailsBYID', "greenLeafReceivingDetailsID=" + parseInt(greenLeafReceivingDetailsID));
   return response.data;
 }
 async function getEstateByGroupID(groupID) {
  let response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  let factoryArray = [];
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
};

async function DeleteGreenLeafReceivingDetails(model) {
  let response = await CommonPost('/api/GreenLeafReceive/DeleteGreenLeafReceivingData', null, model);
  return response;
};
  









